import React, { FunctionComponent } from "react"


const RMTemplateSVG: FunctionComponent<{}> = () => {
    return (
        <div className="RMTemplateSVG">
            <svg fill="#000000" width="37px" height="37px" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path d="M9,14h2V7.77h2V6H7V7.77H9ZM2,2V18H18V2ZM16,16H4V4H16Z" />
                </g>
            </svg>
        </div>
    )
}

export default RMTemplateSVG